import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=fcdbb1f4&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcdbb1f4')) {
      api.createRecord('fcdbb1f4', component.options)
    } else {
      api.reload('fcdbb1f4', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=fcdbb1f4&", function () {
      api.rerender('fcdbb1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wa3ZxpxukFMC/JS/pricehelp.vue"
export default component.exports